import { Button } from '@w7/ui'
import { claims, logout } from '@/auth/oidc'

import { LoginStage } from './LoginStage'
import { StrixMark } from './StrixMark'
import './auth.css'

/**
 * Shown when the signed-in user cannot use this product.
 * Keep copy generic — do not mention hierarchy levels or account types.
 */
export function NoAccessPage() {
  const who = claims()
  const label = who?.preferredUsername || who?.email || who?.sub || 'This account'

  return (
    <div className="w7-auth" data-testid="no-access">
      <LoginStage />
      <div className="w7-auth-panel">
        <div className="w7-auth-panel-bg" aria-hidden="true">
          <img className="w7-auth-panel-bg-a" src="/auth/editorial/form-ai-bg.png" alt="" decoding="async" />
          <img className="w7-auth-panel-bg-b" src="/auth/editorial/form-ai-bg.png" alt="" decoding="async" />
          <div className="w7-auth-panel-veil" />
        </div>
        <div className="w7-auth-card">
          <div className="w7-auth-brand">
            <StrixMark className="w7-auth-mark-word" size={48} />
          </div>

          <p className="w7-auth-eyebrow">Access</p>
          <h1 className="w7-auth-title">No access</h1>
          <p className="w7-auth-alert" role="status" data-testid="no-access-message">
            {label} does not have access.
          </p>

          <div className="w7-auth-actions" style={{ marginTop: 16 }}>
            <Button
              variant="primary"
              data-testid="back-to-login"
              onClick={() => logout({ silent: true })}
            >
              Sign out &amp; switch account
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
